module.exports = __webpack_public_path__ + "static/media/logo7.6a734551.png";